module.exports = __webpack_public_path__ + "static/media/artesanos.b7eb0f63.jpg";